import React from 'react'

import { Order } from '../redux/types'

const OrderAddress: React.FC<{ order: Order }> = ({ order: { address } }) => {
  return (
    <div className="row margin-tb-16">
      <h4>{ address.alias }</h4>
      <p>
        { address.street || 'Logradouro' },&nbsp;
        Nº { address.number || 'S/N' } { address.district || 'Bairro' }
      </p>
      <p>{ address.city || 'Cidade' } - { address.state || 'UF' }</p>
      <p>{ address.complement || 'Complemento' }</p>
    </div>
  )
}

export default OrderAddress
